//* 면세계산서 요청 목록 페이지 — 수기환불과 페이지 분리 운영 (공용 컨텐츠: OrderRequestListContent)
import { FC } from 'react';

import { OrderRequestListContent } from '@service/seller/containers/OrderRequestList/OrderRequestListContent';

import { useSellerTopNavHook } from '../hooks/useSellerTopNavHook';

export const SellerTaxInvoiceRequestPage: FC = function SellerTaxInvoiceRequestPage() {
  useSellerTopNavHook('면세계산서요청');
  return (
    <div className="mx-auto max-w-6xl px-4 pb-8 sm:px-6 lg:px-8">
      <div className="mt-8">
        <OrderRequestListContent kind="taxInvoiceRequest" />
      </div>
    </div>
  );
};
